export function highlightText(text: string, searchValue?: string): React.ReactNode {
  if (!searchValue) {
    return text
  }
  // Escape special regex characters to prevent errors like "Unterminated group"
  const escapedSearchValue = searchValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const regex = new RegExp(`(${escapedSearchValue})`, 'gi')
  const parts = text.split(regex)
  return parts.map((part, i) =>
    regex.test(part) ? (
      <mark
        key={i}
        className="bg-secondary-focused rounded-xs text-[#5c8c0c]"
      >
        {part}
      </mark>
    ) : (
      part
    ),
  )
}
